// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// <summary>
/// Описание процесса выделения
/// </summary>
export class Selection {
    constructor() {
        /// <summary>
        /// текущий режим выделения тулзы
        /// </summary>
        this.CurrentState = SelectionState.None;
        /// <summary>
        /// Выделена точка N тулзы
        /// </summary>
        this.SelectedPointNo = -1;
    }
    /// <summary>
    /// сброс выделения
    /// </summary>
    ClearSelection() {
        this.CurrentState = SelectionState.None;
    }
}
export var SelectionState;
(function (SelectionState) {
    SelectionState[SelectionState["None"] = 0] = "None";
    SelectionState[SelectionState["Hovered"] = 1] = "Hovered";
    SelectionState[SelectionState["Selected"] = 2] = "Selected";
})(SelectionState || (SelectionState = {}));
export var ToolSelectionType;
(function (ToolSelectionType) {
    ToolSelectionType[ToolSelectionType["None"] = 0] = "None";
    ToolSelectionType[ToolSelectionType["Line"] = 1] = "Line";
    ToolSelectionType[ToolSelectionType["Icon"] = 2] = "Icon";
    ToolSelectionType[ToolSelectionType["SL"] = 3] = "SL";
    ToolSelectionType[ToolSelectionType["TP"] = 4] = "TP";
    ToolSelectionType[ToolSelectionType["Action"] = 5] = "Action";
    ToolSelectionType[ToolSelectionType["Remove"] = 6] = "Remove";
    ToolSelectionType[ToolSelectionType["Info"] = 7] = "Info";
    ToolSelectionType[ToolSelectionType["Trailing"] = 8] = "Trailing";
    ToolSelectionType[ToolSelectionType["Image"] = 9] = "Image";
    ToolSelectionType[ToolSelectionType["LimitIcon"] = 10] = "LimitIcon";
    ToolSelectionType[ToolSelectionType["LimitQuantity"] = 11] = "LimitQuantity";
    ToolSelectionType[ToolSelectionType["LimitInfo"] = 12] = "LimitInfo";
    ToolSelectionType[ToolSelectionType["AcceptPlacing"] = 13] = "AcceptPlacing";
    ToolSelectionType[ToolSelectionType["CancelPlacingSL"] = 14] = "CancelPlacingSL";
    ToolSelectionType[ToolSelectionType["CancelPlacingTP"] = 15] = "CancelPlacingTP";
    ToolSelectionType[ToolSelectionType["SideSelect"] = 16] = "SideSelect";
    ToolSelectionType[ToolSelectionType["QuantitySelect"] = 17] = "QuantitySelect";
    ToolSelectionType[ToolSelectionType["OrderTypeSelect"] = 18] = "OrderTypeSelect";
    ToolSelectionType[ToolSelectionType["OrderTifSelect"] = 19] = "OrderTifSelect";
    ToolSelectionType[ToolSelectionType["Leverage"] = 20] = "Leverage";
    ToolSelectionType[ToolSelectionType["Container"] = 21] = "Container";
    ToolSelectionType[ToolSelectionType["LinkTooltip"] = 22] = "LinkTooltip";
    ToolSelectionType[ToolSelectionType["SecondOrder"] = 23] = "SecondOrder";
})(ToolSelectionType || (ToolSelectionType = {}));
